/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-16 11:03:58
 */
import { Form, Divider } from "antd";
import { BarChart } from "../components/barChart";
import {
  getSupportUserDataManage,
  getSupportTrainDataManage,
  getSupportLearnView,
} from "@root/common/service";
import { useEffect, useState } from "react";
import SubjectSelect from "@root/components/selectBox/subjectSelect";
export interface EchartHostitalDataProps {
  averageWatchTime: number;
  instituteId: number;
  instituteName: string;
  learnRatio: number;
  learnRatioText: string;
  learnUserCount: number;
  userCount: number;
  watchTime: number;
}
export interface EchartUserDataProps {
  instituteId: number;
  instituteName: string;
  learnUserCount: number;
  userCount: number;
}
export interface EchartTrainDataProps {
  instituteId: number;
  instituteName: string;
  learnRatio: number;
  learnRatioText: string;
  learnUserCount: number;
  userCount: number;
}
const China = () => {
  const [hospitalChartData, setHospitalChartData] = useState<[]>([]);
  const [learningChartData, setLearningChartData] = useState<[]>([]);
  const [percentOfPassData, setPercentOfPassData] = useState<[]>([]);

  async function getOverAllOverViewData(subject?: number | undefined) {
    const { data: hospitalData } = await getSupportUserDataManage({ subjectId: subject });
    const { data: userData } = await getSupportLearnView({ subjectId: subject });
    const { data: trainData } = await getSupportTrainDataManage({ subjectId: subject });
      
    const initHospitalData: [] = hospitalData.map((item: EchartHostitalDataProps) => {
      return [
        item.instituteName,
        item.watchTime,
        item.averageWatchTime,
      ];
    })
    const initLearningData: [] = userData.map((item: EchartUserDataProps) => {
      return [
        item.instituteName,
        item.userCount,
        item.learnUserCount,
      ];
    })
    const initPercentData: [] = trainData.map((item: EchartTrainDataProps) => {
      return [
        item.instituteName,
        item.learnRatio,
      ];
    })

    setHospitalChartData(initHospitalData);
    setLearningChartData(initLearningData);
    setPercentOfPassData(initPercentData);
  }
  useEffect(() => {
    getOverAllOverViewData();
  }, []);
  const onSelectChangeHandle = (value: any) => {
    if (value === 'all') {
      value = undefined;
    }

    getOverAllOverViewData(value)
  }
  return (
    <div>
      <Form>
        <SubjectSelect
          label={false}
          showAll={true}
          styles={{ width: 160 }}
          onSelect={(value) => { onSelectChangeHandle(value) }}
        />
      </Form>
      <Divider/>
      <BarChart
        id="hospital" 
        subtitle="单位：家"
        dimensions={["学习时长", "平均学习时长"]}
        sources={hospitalChartData} 
        hideExport={true}
      />
      <BarChart 
        id="learning"
        subtitle="单位：人"
        dimensions={["注册人数", "学习人数"]}
        sources={learningChartData} 
        hideExport={true}
      />
      <BarChart 
        id="percent"
        subtitle="单位：%"
        dimensions={["培训率"]}
        sources={percentOfPassData} 
        hideExport={true}
      />
    </div>
  );
};

export default China;
